import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

import { ORDERED_TABLE_COLUMNS } from '../constants';
import { Row, Cell } from '../../../components/table';

const StyledCell = styled(Cell)`
  && {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    height: ${spacing.double};
    min-width: ${spacing.double};
    box-sizing: content-box;
  }
`;

type EventHistorySkeletonRowProps = {
  index: number;
};

export const EventHistorySkeletonRow = ({ index }: EventHistorySkeletonRowProps) => (
  <Row index={index}>
    {ORDERED_TABLE_COLUMNS.map((id) => (
      <StyledCell columnId={id} key={id}>
        <Skeleton />
      </StyledCell>
    ))}
  </Row>
);
